import { render, staticRenderFns } from "./pcHeader.vue?vue&type=template&id=09f84015"
import script from "./pcHeader.vue?vue&type=script&lang=js"
export * from "./pcHeader.vue?vue&type=script&lang=js"
import style0 from "./pcHeader.vue?vue&type=style&index=0&id=09f84015&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports